import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ProfileSettings } from 'src/app/models/server/profile-settings';

@Injectable({
    providedIn: 'root',
})
export class ProfileSettingsStateService {
    private onProfileSettingsChange = new BehaviorSubject<ProfileSettings>(null);

    constructor() {}

    get onProfileSettingsChange$() {
        return this.onProfileSettingsChange.asObservable();
    }

    // Retourne le paramétrage du profil
    public getProfileSettings(): ProfileSettings {
        return this.onProfileSettingsChange.value;
    }

    // Spécifie le paramétrage du profil
    public setProfileSettings(settings: ProfileSettings) {
        this.onProfileSettingsChange.next(settings);
    }
}
